module.exports = __webpack_public_path__ + "static/img/1.a61e737.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/third/1.png
// module id = 8BoE
// module chunks = 6